// extracted by mini-css-extract-plugin
module.exports = {"list":"SuggestionTextInputField_list__2QpM4"};